export default "__VITE_ASSET__BuHUfVA1__"